import { InfoIcon } from "lucide-react";
import type { ReactNode } from "react";
import React from "react";

interface IFooterDataDisclaimerProps extends React.HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export default function FooterDataDisclaimer({ children, ...props }: IFooterDataDisclaimerProps) {
  return (
    <div className="flex justify-center" {...props}>
      <div className="flex items-center space-x-2 rounded-md border border-slate-300 bg-slate-100 p-3 lg:rounded-full lg:px-2 lg:py-2">
        <div>
          <InfoIcon className="hidden size-5 text-slate-600 lg:inline-flex" />
        </div>
        <p className="m-0 text-sm tracking-wider text-slate-500">{children}</p>
      </div>
    </div>
  );
}
